import { useTranslation } from 'react-i18next';

import PanelRow from '../../../../../../../../shared/components/ProfileCards/PanelRow/PanelRow';
import type { IClientContact } from '../../../../../../../../shared/interfaces/clients';
import { TRANSLATIONS_CLIENTS } from '../../../../../../../../shared/translations/clients';
import { TRANSLATIONS_GLOBAL } from '../../../../../../../../shared/translations/commons';
import { TRANSLATIONS_PROSPECTS } from '../../../../../../../../shared/translations/prospects';
import { ClientContactType } from '../../../../../../../../shared/types/clients';

import '../../../../../../../../shared/components/ProfileCards/BillingContactCard/BillingContactCard.scss';

const PROSPECT_PROFILE = TRANSLATIONS_PROSPECTS.profile;

const contactDisplayName = (contact: IClientContact): string =>
  contact.name || [contact.firstName, contact.lastName].filter(Boolean).join(' ') || '—';

interface IActiveContactsProps {
  contacts: IClientContact[];
}

const ActiveContacts = ({ contacts }: IActiveContactsProps) => {
  const { t } = useTranslation();

  if (contacts.length === 0) {
    return (
      <div className="client-data-card__section">
        <p className="profile-card__empty-hint">{t(TRANSLATIONS_CLIENTS.profile.contacts.empty)}</p>
      </div>
    );
  }

  return (
    <>
      {contacts.map((contact, index) => {
        const isPrimary = contact.contactTypes.includes(ClientContactType.Administrator);
        const isBilling = contact.contactTypes.includes(ClientContactType.PaymentManager);

        let sectionTitle = '';
        if (isPrimary) {
          sectionTitle = t(PROSPECT_PROFILE.primaryContact.title);
        } else if (isBilling) {
          sectionTitle = t(PROSPECT_PROFILE.billingContact.title);
        }

        return (
          <div key={contact.id}>
            <div className="client-data-card__section">
              <h4 className="client-data-card__section-title">{sectionTitle}</h4>
              <PanelRow label={t(TRANSLATIONS_GLOBAL.name)} value={contactDisplayName(contact)} />
              <PanelRow label={t(TRANSLATIONS_GLOBAL.email)} value={contact.email} />
              <PanelRow label={t(TRANSLATIONS_GLOBAL.phone)} value={contact.phone || '—'} empty={!contact.phone} />
            </div>

            {isPrimary && isBilling && (
              <>
                <div className="client-data-card__divider" />
                <div className="client-data-card__section">
                  <h4 className="client-data-card__section-title">{t(PROSPECT_PROFILE.billingContact.title)}</h4>
                  <div className="billing-same-display">
                    <span className="billing-same-display__title">{t(PROSPECT_PROFILE.form.sameAsPrimary)}</span>
                  </div>
                </div>
              </>
            )}

            {index < contacts.length - 1 && <div className="client-data-card__divider" />}
          </div>
        );
      })}
    </>
  );
};

export default ActiveContacts;
